export default {
  path: '/relatorios-de-amostragem/:id',
  component: () =>
    import('@/components/pages/SamplingReports/SamplingReport.vue')
}
